module.exports = __webpack_public_path__ + "static/media/expressive2.5c58ea9e.png";